export const UPDATE_TAGS = 'UPDATE_TAGS'
